/**
 * computeUserInitials
 *
 * Returns a 1–2 character uppercase string suitable for an avatar fallback
 * when the user has no profile image. Picks the FIRST word's leading char
 * and the LAST word's leading char — for "Mary Jane Watson" returns "MW",
 * not "MJ". Single-name users ("Madonna") return a single char.
 *
 * Trim + split on whitespace runs so multi-space and tab-separated names
 * resolve cleanly. Empty / whitespace-only input returns 'U' (caller can
 * already fall back to 'U' on `!name` — this is defense-in-depth).
 */
export function computeUserInitials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return 'U';
  const first = words[0]?.[0] ?? '';
  if (words.length === 1) return first.toUpperCase();
  const last = words[words.length - 1]?.[0] ?? '';
  return `${first}${last}`.toUpperCase();
}
